//export module getters as root getters
export const getCurrentEtablissement=(state:any,getters:any)=>getters["etablissements/getCurrentEtablissement"];
export const getIndividu=(state:any,getters:any)=>getters["individus/getIndividu"];
export const getListIndividus=(state:any,getters:any)=>getters["individus/getListIndividus"];
export const getFiltredListIndividus=(state:any, getters:any)=>getters["individus/getFiltredListIndividus"];
export const getListPointagesPrevi=(state:any, getters:any)=>getters["pointages/getListPointagesPrevi"];
export const getPointageEnCours=(state:any, getters:any)=>getters["pointages/getPointageEnCours"];


const eqSet = (xs:Set<String>, ys:Set<String>) =>xs!==undefined && ys!==undefined && xs.size === ys.size &&    [...xs].every((x) => ys.has(x));

export const getFiltredListIndividusWithPointages=(state:any, getters:any)=>{

  const pointagesParIndividu=getters.getPointageEnCours.reduce(function (r:any, a:any) {
      if(!r.has(a.getIdIndividu())){
        r.set(a.getIdIndividu(), [])
      }
      r.get(a.getIdIndividu()).push(a)
      return r;
  }, new Map())
   
  const start = Date.now();

   if(getters.getPointageEnCours.length>0)
   getters.getFiltredListIndividus.forEach((i:any)=>{
    const newPointagesIndividu=pointagesParIndividu.get(i.getId())

    const newPointagesIndividuSet=new Set<String>(newPointagesIndividu);
    const currentPointageIndividuSet=new Set<String>(i.getPointages());
       
      if( !eqSet(newPointagesIndividuSet, currentPointageIndividuSet) ){   
  
        i.setPointages(newPointagesIndividuSet)
       
        i.setEtime(start);
      }else{
        //console.log("same list"+i.get_id())
      }
       
    
   
    return i;
});
 return  getters.getFiltredListIndividus

};



export const getListPalettePresence=(state:any, getters:any)=>getters["pointages/getListPalettePresence"];
export const getListPaletteAbsence=(state:any, getters:any)=>getters["pointages/getListPaletteAbsence"];
export const getListSupplementsPrevi=(state:any, getters:any)=>getters["pointages/getListSupplementsPrevi"];
export const getCurrentActivite=(state:any,getters:any)=>getters["activites/getCurrentActivite"];
export const getDate=(state:any,getters:any)=>getters["activites/getDate"];
export const getListTempsAccueilFiltred=(state:any, getters:any)=>getters["pointages/getListTempsAccueilFiltred"];
export const getListSupplementsFiltred=(state:any, getters:any)=>getters["pointages/getListPointagesPrevi"];


/* Il est utiliser dans route/index => beforeEach() */
export const isAuthenticated=(state:any,getters:any)=>getters["session/isAuthenticated"];
export const getCurrentUser=(state:any,getters:any)=>getters["moncompte/getCurrentUser"];
export const isUserLogedIn=(state:any,getters:any)=>getters["moncompte/isUserLogedIn"];
